export default {
  devStoreConfig: false,
  api: {
    default: 'https://stormy-harbor-92912.herokuapp.com/v0',
  },
  features: {
    Ledger: false,
    BTC: false,
    BOT: false,
    Ebay: false,
    balanceSelling: false,
  }
};



// WEBPACK FOOTER //
// ./config/config.client16.js